import $ from 'jquery';

export default class FAQBookmarks {
    constructor() {
        $('.secfaqbookmarks__bookmark').first().toggleClass('secfaqbookmarks__inactive');
        $('.secfaqbookmarks__answer').first().toggleClass('secfaqbookmarks__active');
        $('.secfaqbookmarks__wrapper-faq').first().toggleClass('secfaqbookmarks__hidden');
        $('.secfaqbookmarks__icon').first().toggleClass('secfaqbookmarks__active-icon');
        $('.secfaqbookmarks__bookmark').on('click', function () {
            $('.secfaqbookmarks__answer').removeClass('secfaqbookmarks__active');
            $('.secfaqbookmarks__bookmark').addClass('secfaqbookmarks__inactive');
            $('.secfaqbookmarks__icon').removeClass('secfaqbookmarks__active-icon');
            $(this).toggleClass('secfaqbookmarks__inactive');
            var bookmarkIndex = $(this).attr('id').replace(/secfaqbookmarks__bookmark-/, '');
            $('.secfaqbookmarks__wrapper-faq').addClass('secfaqbookmarks__hidden');
            $('#secfaqbookmarks__faq-'+bookmarkIndex).toggleClass('secfaqbookmarks__hidden');
        });
        $('.secfaqbookmarks__wrapper-question').on('click', function () {
            var mainIndex = $(this).attr('id').match("secfaqbookmarks__question-(.*)_")[1];
            var questionIndex = $(this).attr('id').replace('secfaqbookmarks__question-'+mainIndex+'_', '');
            $('.secfaqbookmarks__answer').removeClass('secfaqbookmarks__active');
            $('.secfaqbookmarks__icon').removeClass('secfaqbookmarks__active-icon');
            $('#secfaqbookmarks__answer-'+mainIndex+'_'+questionIndex).toggleClass('secfaqbookmarks__active');
            $('#secfaqbookmarks__icon-'+mainIndex+'_'+questionIndex).toggleClass('secfaqbookmarks__active-icon');
        });
    }
}
